import React, { useEffect, useState } from 'react';
import {
    Wrapper,
    ContentArea,
    StyledImage,
    PaginationWrapper,
    PageButton
} from './styled';
import {useImageUrl} from "../../../../queries";

export const ImageSwitcher = ({images = []}) => {
    const [activePage, setActivePage] = useState(0);
    const [fade, setFade] = useState(true);
    
    const totalPages = images.length || 0;
    const activeImageId = images[activePage]?.directus_files_id;
    const activeImageUrl = useImageUrl(activeImageId);

    useEffect(() => {
        if (totalPages === 0) return;
        
        const timer = setInterval(() => {
            setFade(false);
            setTimeout(() => {
                setActivePage((prevPage) => (prevPage + 1) % totalPages);
                setFade(true);
            }, 300);
        }, 5000);

        return () => clearInterval(timer);
    }, [totalPages]);

    const handleClick = (index) => {
        setFade(false);
        setTimeout(() => {
            setActivePage(index);
            setFade(true);
        }, 300);
    };

    if (totalPages === 0 || !activeImageUrl) {
        return null;
    }

    return (
        <Wrapper>
            <ContentArea>
                <StyledImage
                    src={activeImageUrl}
                    alt={`Content image ${activePage + 1}`}
                    $fade={fade}
                />
            </ContentArea>
            <PaginationWrapper>
                {images.map((_, index) => (
                    <PageButton
                        key={index}
                        active={activePage === index}
                        onClick={() => handleClick(index)}
                    >
                        {index + 1}
                    </PageButton>
                ))}
            </PaginationWrapper>
        </Wrapper>
    );
};
